import { memo } from "react";

import { LoadingOverlay } from "../../../../components/LoadingOverlay/LoadingOverlay";
import type { IQueryParams } from "../../../../hooks/reactQueryHooks/useOrganization";
import { useOrganizationInvitations } from "../../../../hooks/reactQueryHooks/useOrganization";
import { useQueryParams } from "../../../../hooks/useQueryParams";
import { InvitationsTable } from "../InvitationsTable";

interface InvitationsPageProps {
  currentOrganizationId: string;
}

export const InvitationsPage: React.FC<InvitationsPageProps> = memo(
  ({ currentOrganizationId }) => {
    const { queryValue: searchQuery } = useQueryParams({
      queryStr: "s",
    });
    const { queryValue: pageIndex } = useQueryParams({
      queryStr: "p",
    });

    const { queryValue: status } = useQueryParams({
      queryStr: "status",
    });

    const params: IQueryParams = {
      pageSize: 10,
      pageIndex: pageIndex ? Number(pageIndex) - 1 : 0,
      search: searchQuery || "",
      status: status || "",
      orderBy: "createdAt",
      desc: true,
    };

    const { data, isLoading, isFetching } = useOrganizationInvitations(
      currentOrganizationId,
      params,
    );

    return (
      <>
        <InvitationsTable
          data={data}
          pageIndex={data?.pageIndex}
          pageSize={data?.pageSize}
          totalCount={data?.totalCount || 0}
          isLoading={isLoading}
          currentOrganizationId={currentOrganizationId}
        />

        {(isLoading || isFetching) && <LoadingOverlay />}
      </>
    );
  },
);
